<template>
    <div>
        <b-modal :id="modalId"
                modal-class="modal-alert"
                centered
                hide-header
                hide-footer
                no-close-on-backdrop
                no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-head">
                    <p id="alert_title">{{title}}</p>
                </div>
                <div class="modal-base-body">
                    <p id="alert_msg" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="alert_btn_row">
                        <div class="alert-modal-btn">
                            <PrimaryButton
                                btnId="confirm_alert_btn"
                                :btnMsg="btnConfirm"
                                @clickButton="clickConfirm()" />
                        </div>
                        <div class="alert-modal-btn">
                            <SecondaryButton
                                btnId="cancel_alert_btn"
                                :btnMsg="btnCancel"
                                @clickButton="clickCancel()" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// components
import SecondaryButton from "@/components/Button/SecondaryButton.vue";
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "AlertModal",
    mixins: [LocaleMixin],
    components: {
        PrimaryButton,
        SecondaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String,
    },
     data: function() {
        return {
            title: '',
            message: '',
            btnConfirm: '',
            btnCancel: '',
            tag: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickConfirm: function () {
            this.hide();
        },
        clickCancel: function () {
            this.hide();
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnConfirm = config.btnConfirm;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.title))
                this.title = this.lbl.default.error_title;

            if (Util.isEmptyStr(config.btnConfirm))
                this.btnConfirm = this.lbl.default.confirm;

            if (Util.isEmptyStr(config.btnCancel))
                this.btnCancel = this.lbl.default.cancel;

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#alert_title {
    color: $color-gray;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
}

#alert_msg {
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 24px;
}

#alert_btn_row {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-alert {
    @extend %modal-base;

    .modal-dialog {
        max-width: 300px;
    }

    .modal-body {
        padding: 30px 20px;
    }
}
</style>
